export default __webpack_public_path__ + "static/media/tsu.c3dcd401.jpg";